import { Controller } from "@hotwired/stimulus";

// Keeps a dismissed alert closed for the rest of the browser session.
// Relies on Bootstrap's alert component firing "closed.bs.alert" when the
// built-in .btn-close (data-bs-dismiss="alert") is clicked.
export default class extends Controller {
  connect() {
    // To prevent the alert from flashing on the screen before being hidden,
    // we hide it by default and only display it if it hasn't been hidden.
    if (sessionStorage.getItem(this.storageKey)) {
      return;
    } else {
      this.element.classList.remove("d-none");
    }

    this.element
      .querySelector(".alert")
      .addEventListener("closed.bs.alert", () => {
        sessionStorage.setItem(this.storageKey, "1");
      });
  }

  get storageKey() {
    return `alert-dismissed:${this.element.id}`;
  }
}
